export default "__VITE_ASSET__CDEg$gIP__"